export default __webpack_public_path__ + "static/media/image-cushion-g-w@3x.9aba125e.png";